import React, {useState, useEffect} from "react";
import {
  Main,
  AboutMe,
  Timeline,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';
import { trackScrollDepth } from './utils/mixpanel';

function App() {
    const [mode, setMode] = useState<string>('light');

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    // Track scroll depth
    useEffect(() => {
        let lastTrackedDepth = 0;
        const trackScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollDepth = Math.round((scrollTop / documentHeight) * 100);
            
            // Track at 25%, 50%, 75%, and 100% milestones
            if (scrollDepth >= 25 && lastTrackedDepth < 25) {
                trackScrollDepth(25);
                lastTrackedDepth = 25;
            } else if (scrollDepth >= 50 && lastTrackedDepth < 50) {
                trackScrollDepth(50);
                lastTrackedDepth = 50;
            } else if (scrollDepth >= 75 && lastTrackedDepth < 75) {
                trackScrollDepth(75);
                lastTrackedDepth = 75;
            } else if (scrollDepth >= 100 && lastTrackedDepth < 100) {
                trackScrollDepth(100);
                lastTrackedDepth = 100;
            }
        };

        window.addEventListener('scroll', trackScroll, { passive: true });
        return () => window.removeEventListener('scroll', trackScroll);
    }, []);

    return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
        <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
        <FadeIn transitionDuration={700}>
            <Main/>
           
            <Expertise/>
            <AboutMe/>
            <Timeline/>
            <Project/>
            <Contact/>
        </FadeIn>
        <Footer />
    </div>
    );
}

export default App;